export type VisitOrgOrTeamArgs = {
    orgSlug: string,
    teamSlug?: string | null,
    alias?: string | null,
    query?: Record<string, string>
};

/**
 * Redirects the browser to the dashboard page for an organization. If a team is also provided we will redirect to that team
 * The user must have permission to visit this org/team or else the request will simply fail
 */
export default function VisitOrganizationOrTeam({
    orgSlug,
    teamSlug = null,
    alias = null,
    query = {},
}: VisitOrgOrTeamArgs): void {
    const theRouter = window.$router;

    const theQuery: Record<string, string> = {
        ...query,
    };

    if (alias) {
        theQuery["alias"] = alias;
    }

    theRouter.push({
        name: teamSlug ? "org.team" : "org.dashboard",
        query: theQuery,
        params: {
            org: orgSlug,
            ...(teamSlug && { team: teamSlug }),
        },
    });
}
